import React, { useState, useEffect, useContext } from "react";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./dashboard.css";
import TextBox from "devextreme-react/text-box";
import Grid from "../grid/grid";
import { dashboardMapperMethod } from "../../helpers/dashboardMapper";
import {
  getMachines,
  getProperties,
  getDashboardData,
  deleteDashboard,
  getAllWidgetsData,
  saveDashboardData
} from "../../services/service";
import "react-datepicker/dist/react-datepicker.css";
import SelectBox from "devextreme-react/select-box";
import { Button } from "devextreme-react/button";
import DateRange from "../date-range/dateRange";
import { DateContext } from "../navigation/navigationDrawer";
import Notify from 'devextreme/ui/notify';


const gridItemConfig = { x: 0, y: 0, w: 20, h: 5.5, minW: 4, minH: 5.5 };

const Dashboard = () => {

  const { setSelectedDate } = useContext(DateContext);
  const displayModeOptions = ["View", "Edit"];
  const [modeType, setModeType] = useState(displayModeOptions[0]);
  const [isEdit, setIsEdit] = useState(false);
  const [isDataLoadingByDate, setIsDataLoadingByDate] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const [chartDataModelObjects, setchartDataModelObjects] = useState([]);
  const [dashboardName, setDashboardName] = useState("");
  const [dashboardList, setDashboardList] = useState([]);
  const [isNameEmpty, setIsNameEmpty] = useState(true);
  const [machineValues, setMachineValues] = useState(null);
  const [propertyValues, setPropertyValues] = useState(null);
  const [savedWidgets, setSavedWidgets] = useState([]);
  const [selectedWidget, setSelectedWidget] = useState([]);
  const [gridItems, setGridItems] = useState([
    {
      key: "1",
      x: gridItemConfig.x,
      y: gridItemConfig.y,
      w: gridItemConfig.w,
      h: gridItemConfig.h,
      minW: gridItemConfig.minW,
      minH: gridItemConfig.minH,
    },
  ]);


  const setDashboard = () => {
    getDashboardData().then((responseData) => {
      if (responseData.length > 0) {
        setDashboardData(responseData);
        let dashboardNames = [];
        responseData.map((data) => dashboardNames.push(data.name));
        setDashboardName(dashboardNames[0]);
        setDashboardList(dashboardNames);
        setIsNameEmpty(false);
        const { chartsModelList, gridItemsList } = dashboardMapperMethod(
          dashboardNames[0],
          responseData,
          gridItemConfig
        );
        setchartDataModelObjects(chartsModelList);
        setGridItems(gridItemsList);
      }
    });
  };

  const postDashboardData = () => {
    const chartsDataModel = {
      name: dashboardName,
      dashboards: chartDataModelObjects,
    };
    saveDashboardData(chartsDataModel)
      .then((response) => {
        Notify({
          message: response.res,
          type: 'success',
          displayTime: 3500,
          animation: {
            show: {
              type: 'fade', duration: 400, from: 0, to: 1,
            },
            hide: { type: 'fade', duration: 40, to: 0 },
          },
        }, {
          position: 'bottom center',
          direction: 'up-push',
        });
        let newDashboardList = dashboardList;
        newDashboardList.push(dashboardName);
        setDashboardList(newDashboardList);
      })
      .catch((error) => {
        // handle error
        console.error(error.response.data.error);
        Notify({
          message: error.response.data.error,
          type: 'error',
          displayTime: 3500,
          animation: {
            show: {
              type: 'fade', duration: 400, from: 0, to: 1,
            },
            hide: { type: 'fade', duration: 40, to: 0 },
          },
        }, {
          position: 'bottom center',
          direction: 'up-push',
        });
      });
  };

  useEffect(() => {
    setDashboard();
    getMachines().then((machines) => {
      setMachineValues(machines);
    });
    getProperties().then((properties) => {
      setPropertyValues(properties);
    });
    getAllWidgetsData().then((widgets) => {
      setSavedWidgets(widgets);
      if (widgets.length > 0) setSelectedWidget(widgets[0]);
    });
  }, []);

  const addGridItem = () => {
    if (gridItems.length > 0) {
      const newKey = (
        parseInt(gridItems[gridItems.length - 1].key) + 1
      ).toString();
      setGridItems([
        ...gridItems,
        {
          key: newKey,
          x: gridItemConfig.x,
          y: Infinity,
          w: gridItemConfig.w,
          h: gridItemConfig.h,
          minW: gridItemConfig.minW,
          minH: gridItemConfig.minH,
        },
      ]);
    } else {
      setGridItems([
        {
          key: "1",
          x: gridItemConfig.x,
          y: gridItemConfig.y,
          w: gridItemConfig.w,
          h: gridItemConfig.h,
          minW: gridItemConfig.minW,
          minH: gridItemConfig.minH,
        },
      ]);
    }
  };

  const addWidget = () => {
    if (gridItems.length > 0) {
      const newKey = (
        parseInt(gridItems[gridItems.length - 1].key) + 1
      ).toString();
      setGridItems([
        ...gridItems,
        {
          key: newKey,
          x: gridItemConfig.x,
          y: Infinity,
          w: gridItemConfig.w,
          h: gridItemConfig.h,
          minW: gridItemConfig.minW,
          minH: gridItemConfig.minH,
          dashboards: [selectedWidget],
        },
      ]);
    } else {
      setGridItems([
        {
          key: "1",
          x: gridItemConfig.x,
          y: gridItemConfig.y,
          w: gridItemConfig.w,
          h: gridItemConfig.h,
          minW: gridItemConfig.minW,
          minH: gridItemConfig.minH,
          dashboards: [selectedWidget],
        },
      ]);
    }
  };

  const onLayoutChange = (currentLayout) => {
    let newLayout = [];
    currentLayout.map((item) => {
      let gridObject = {
        key: item.i,
        x: item.x,
        y: item.y,
        w: item.w,
        h: item.h,
        minW: item.minW,
        minH: item.minH,
      };
      newLayout.push(gridObject);
    });
    updateChartDataModelObjects(newLayout);
  };

  const updateChartDataModelObjects = (newLayout) => {
    const updatedChartModelData = [];
    chartDataModelObjects.forEach((chartDataModel) => {
      const matchingItem = newLayout.find(
        (newLayoutItem) => newLayoutItem.key === chartDataModel.key
      );
      if (matchingItem) {
        // Merge properties from newLayout into chartDataModelObjects
        updatedChartModelData.push({ ...chartDataModel, ...matchingItem });
      }
      return chartDataModel;
    });
    setGridItems(newLayout);
    setchartDataModelObjects(updatedChartModelData);
  };

  /**
   * ALL the input field handlers are defined below
   */
  const displayMode = (mode) => {
    let modeFlag = mode === "Edit" ? true : false;
    setIsEdit(modeFlag);
    setModeType(mode);
    if (!modeFlag) setDashboard();
  };

  const saveLayout = () => {
    if (isNameEmpty) {
      Notify({
        message: "Please enter a dashboard name",
        type: 'error',
        displayTime: 3500,
        animation: {
          show: {
            type: 'fade', duration: 400, from: 0, to: 1,
          },
          hide: { type: 'fade', duration: 40, to: 0 },
        },
      }, {
        position: 'bottom center',
        direction: 'up-push',
      });
    } else {
      postDashboardData();
    }
  };

  const cancelLayout = () => {
    setIsEdit(false);
    setModeType("View");
  };

  const handleNameChange = (e) => {
    const name = e.value;
    setDashboardName(name);
    const flag = name === "" ? true : false;
    setIsNameEmpty(flag);
  };

  const handleWidgetChange = (e) => {
    setSelectedWidget(e);
  };

  const changeDashboard = (value) => {
    setDashboardName(value);
    setIsNameEmpty(false);
    const { chartsModelList, gridItemsList } = dashboardMapperMethod(
      value,
      dashboardData,
      gridItemConfig
    );
    setchartDataModelObjects(chartsModelList);
    setGridItems(gridItemsList);
  };

  const createNewDashboard = () => {
    setIsEdit(true);
    setModeType(displayModeOptions[1]);
    setGridItems([
      {
        key: "1",
        x: gridItemConfig.x,
        y: gridItemConfig.y,
        w: gridItemConfig.w,
        h: gridItemConfig.h,
        minW: gridItemConfig.minW,
        minH: gridItemConfig.minH,
      },
    ]);
    setchartDataModelObjects([]);
    setDashboardName("");
    setIsNameEmpty(true);
  };

  const deleteCurrentDashboard = () => {
    deleteDashboard(dashboardName).then((response) => {
      Notify({
        message: response.res,
        type: 'success',
        displayTime: 3500,
        animation: {
          show: {
            type: 'fade', duration: 400, from: 0, to: 1,
          },
          hide: { type: 'fade', duration: 40, to: 0 },
        },
      }, {
        position: 'bottom center',
        direction: 'up-push',
      });
      window.location.reload();
    });
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-date-container"><DateRange/></div>
      {machineValues && propertyValues ? (
        <div>
          <div className="options-container">
            <div className="mode-container">
              <SelectBox
                items={displayModeOptions}
                value={modeType}
                onValueChange={(e) => displayMode(e)}
                displayValue={modeType}
                label="Dashboard Mode"
                labelMode="floating"
              ></SelectBox>
            </div>
            {!isEdit && (
              <div className="dashboard-names-create-container">
                <div className="dashboard-names-select">
                  <SelectBox
                    items={dashboardList}
                    value={
                      dashboardName === "" ? "Select Dashboard" : dashboardName
                    }
                    onValueChange={(e) => changeDashboard(e)}
                    displayValue={
                      dashboardName === "" ? "Select Dashboard" : dashboardName
                    }
                  ></SelectBox>
                </div>
                <div className="delete-button">
                  <Button
                    width={"auto"}
                    text="Delete Dashboard"
                    stylingMode="contained"
                    className="delete-button-style button-selection"
                    onClick={deleteCurrentDashboard}
                  />
                </div>
                <div className="create-button">
                  <Button
                    width={"auto"}
                    text="Create New Dashboard"
                    stylingMode="contained"
                    className="create-button-style button-selection"
                    onClick={createNewDashboard}
                  />
                </div>
              </div>
            )}
            {isEdit && (
              <div className="edit-buttons-container">
                <div className="name-container">
                  <TextBox
                    showClearButton={true}
                    placeholder="Enter Dashboard Name"
                    valueChangeEvent="keyup"
                    onValueChanged={handleNameChange}
                    value={dashboardName}
                  />
                </div>
                <div className="add-button">
                  <Button
                    onClick={addGridItem}
                    stylingMode="contained"
                    text="Add Graph"
                    className="create-button-style button-selection"
                  ></Button>
                </div>
                <div className="save-button">
                  <Button
                    onClick={saveLayout}
                    stylingMode="contained"
                    className="save-button-style button-selection"
                    text="Save"
                  ></Button>
                </div>
                <div className="cancel-button">
                  <Button
                    onClick={cancelLayout}
                    stylingMode="contained"
                    className="cancel-button-style button-selection"
                    text="Cancel"
                  ></Button>
                </div>
                <SelectBox
                  items={savedWidgets}
                  value={selectedWidget}
                  onValueChange={(e) => handleWidgetChange(e)}
                  displayExpr={"widgetName"}
                  label="Widgets"
                  labelMode="floating"
                ></SelectBox>
                <div className="add-widget-button">
                  <Button
                    onClick={addWidget}
                    stylingMode="contained"
                    className="create-button-style button-selection"
                    text="Add Widget"
                  ></Button>
                </div>
              </div>
            )}
          </div>
            <Grid
              setGridItems={setGridItems}
              gridItems={gridItems}
              onLayoutChange={onLayoutChange}
              chartDataModelObjects={chartDataModelObjects}
              setchartDataModelObjects={setchartDataModelObjects}
              isEdit={isEdit}
              machineValues={machineValues}
              propertyValues={propertyValues}
              isDataLoadingByDate={isDataLoadingByDate}
              setIsDataLoadingByDate={setIsDataLoadingByDate}
            />
        </div>
      ) : (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
